<template>
<el-container>
  <div v-if="ismobile === false">
    <publicHeader :currencyShow="currencyShow" :curPageData="this.curPageData" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'MyTrip', params: {'querys': common.linkEncode({'source': source, 'conver': conver }, 'obj')}}" v-if="!this.TemporaryOrder">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      </router-link>
      <div style="height:60px;">
        <div style="font-weight: 400; font-style: normal; font-size: 16px; color: #FFFFFF; padding: 10px 0;text-align: center; height: 40px; ">
          <div style="font-size: 12px;font-weight: 100;">{{$t('bookingReference')}}</div>
          <div style="font-size: 16px;">{{orderDetail.orderno}}</div>
        </div>
      </div>
    </div>
  </div>
  <el-main>
      <div class="main">
          <publicAccountMenu v-if="!this.TemporaryOrder"></publicAccountMenu>

          <!-- 我的行程 -->
          <div class="account-show">
              <div class="account-center">
                  <div class="account-data-info">
                      <div class="account-callback" @click="goback" v-if="ismobile === false && !this.TemporaryOrder">
                          <img src="https://res.roompai.com/static/img/account/my-callback.png" alt="">
                          {{$t('back')}}
                      </div>
                      <div style="height:10px;" v-else></div>
                      <div class="data-block order-status-num childpay-block" style="margin-bottom: 10px;" v-if="confirmShow === true && orderDetail.child_order_status === 8">
                        <div class="order-status-img background-childpay">
                            <img src="/static/img/account/my-payment-wait.png">
                        </div>
                        <div class="order-status-desc" style="margin-right:5px;">
                            {{$t('childPayOverTimeTip')}}
                        </div>
                      </div>
                      <div class="data-block order-status-num confirm-block" v-show="confirmShow">
                          <div class="order-status-img background-confirm">
                              <img style="width:30px; height:30px;margin: 10px;" src="https://res.roompai.com/static/img/account/my-payment-yes.png">
                          </div>
                          <div class="order-status-desc">
                              {{$t('yourBookingHasBeenConfirm')}}
                          </div>
                          <div class="order-status-orderno" v-if="ismobile === false">
                              {{$t('bookingReferenceNo')}} {{orderDetail.orderno}}
                          </div>
                      </div>
                      <div class="data-block order-status-num noconfirm-block" v-show="noConfirmShow">
                          <div class="order-status-img background-noconfirm">
                              <img style="width:30px; height:30px;margin: 10px;" src="https://res.roompai.com/static/img/account/my-confirm.png">
                          </div>
                          <div class="order-status-desc" v-if="ismobile === false">
                              <span v-if="check === false">{{$t('orderNoConfirmLeft')}} <span style="font-weight: 650;">{{minuteString+':'+secondString}}</span> <a v-if="language === 'en'">.</a><a v-else>{{$t('orderNoConfirmRight')}}</a></span>
                              <span v-else>{{ $t('orderNoConfirm') }}</span>
                          </div>
                          <div class="order-status-desc" :class="{'twoline': check === false}" :style="{ width: `${msgWidth}px`}" v-else>
                            <span v-if="check === false">{{$t('orderNoConfirmLeft')}} <span style="font-weight: 650;">{{minuteString+':'+secondString}}</span><a v-if="language === 'en'">.</a><a v-else> {{$t('orderNoConfirmRight')}}</a></span>
                            <span v-else>{{ $t('orderNoConfirm') }}</span>
                          </div>
                          <div class="order-status-orderno" v-if="ismobile === false">
                              {{$t('bookingReferenceNo')}} {{orderDetail.orderno}}
                          </div>
                      </div>
                      <div class="data-block order-status-num payment-block" v-show="paymentShow">
                          <div class="order-status-img background-payment">
                              <img style="width:30px; height:30px;margin: 10px;" src="https://res.roompai.com/static/img/account/my-cancel.png">
                          </div>
                          <div class="order-status-desc">
                              {{$t('orderWaitPaymentMess')}}
                          </div>
                          <div class="order-status-orderno" v-if="ismobile === false">
                              {{$t('bookingReferenceNo')}} {{orderDetail.orderno}}
                          </div>
                      </div>
                      <div class="data-block order-status-num cancel-block" v-show="cancelShow">
                          <div class="order-status-img background-cancel">
                              <img src="https://res.roompai.com/static/img/account/my-error.png">
                          </div>
                          <div class="order-status-desc" style="margin-right:5px;">
                              {{$t('yourBookingHasBeenCancelled')}}
                          </div>
                          <div>
                            <img src="/static/img/account/order-detail-cancel.png" style="width:18px; height:18px; cursor: pointer;margin: 16px 0px;" @click="cancelDia = true">
                            <el-dialog :visible.sync="cancelDia" :width="diaWidth" :show-close="taxShowClose" class="tax-margin" top="35vh">
                              <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">
                                {{$t('cancelReason')}}
                              </div>
                              <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;"><a v-if="orderDetail.cancel_reason === '6'">{{$t('cancelForWaitPay')}}</a><a v-else-if="orderDetail.cancel_reason === '7'">{{$t('cancelForWaitConfirm')}}</a></div>
                              <div @click="cancelDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">
                                {{$t('close')}}
                              </div>
                            </el-dialog>
                          <!-- <div class="order-status-desc" v-if="orderDetail.cancel_reason === '6'">
                              {{$t('cancelForWaitPay')}}
                          </div>
                          <div class="order-status-desc" v-else-if="orderDetail.cancel_reason === '7'">
                              {{$t('cancelForWaitConfirm')}}
                          </div> -->
                          <div class="order-status-orderno" v-if="ismobile === false">
                              {{$t('bookingReferenceNo')}} {{orderDetail.orderno}}
                          </div>
                        </div>
                      </div>
                      <div class="data-block order-status-num childpay-block" v-show="childPaymentShow">
                        <div class="order-status-img background-childpay">
                            <img src="/static/img/account/my-payment-wait.png">
                        </div>
                        <div class="order-status-desc" style="margin-right:5px;" v-if="ismobile === false">
                            {{$t('childPayTop')}}
                        </div>
                        <div :class="{'twoline': language === 'en', 'order-status-desc': language === 'zh'}" style="margin-right:5px;" v-else>
                            {{$t('childPayTopMobile')}}
                        </div>
                        <div>
                          <div class="order-status-orderno" v-if="ismobile === false">
                              {{$t('bookingReferenceNo')}} {{orderDetail.orderno}}
                          </div>
                        </div>
                      </div>
                      <div class="mobile-date" v-if="ismobile === true">
                        <div class="mobile-cancel-date" v-if="orderDetail.order_status === '4'">{{$t('cancellationDate')}} {{orderDetail.cancel_date}}</div>
                        <div class="mobile-order-date">{{$t('creationDate')}} {{orderDetail.create_date}}</div>
                      </div>
                      <div class="clearBoth order-roominfo-clear" v-if="ismobile === false"></div>
                      <div class="clearBoth" style="height:10px;" v-else></div>
                      <el-skeleton animated :loading="hotelLoading">
                        <template slot="template">
                          <div class="data-block hotel-info">
                            <el-skeleton-item variant="text" class="hotel-info-img"/>
                            <div class="hotel-info-data">
                              <div class="hotel-info-data-center" style="margin: 20px 20px 20px 10px;">
                                  <div class="hotel-info-hotelname"><el-skeleton-item variant="text"/></div>
                                  <div class="hotel-info-star" style="width: 100px;">
                                    <el-skeleton-item variant="text"/>
                                  </div>
                                  <p class="addr-text">
                                    <span style="height: 100%;margin: auto 0px;"><img src="https://res.roompai.com/static/img/account/my-hoteladdr.png" alt=""></span>
                                    <el-skeleton-item variant="text"/>
                                  </p>
                                  <p style="width: 200px;">
                                    <img src="https://res.roompai.com/static/img/account/my-hotelphone.png" alt=""><el-skeleton-item variant="text"/>
                                  </p>
                                  <p style="width: 200px;">
                                    <img src="https://res.roompai.com/static/img/account/my-hotelemail.png" alt=""><el-skeleton-item variant="text"/>
                                  </p>
                              </div>
                            </div>
                        </div>
                        </template>
                        <template>
                          <el-card :body-style="{ padding: '0px' }">
                            <div class="data-block hotel-info" @click="jumpDetail(hotelDetail.hotelid, hotelDetail.hotelname_lang)">
                                <div class="hotel-info-img" v-if="hotelDetail['pic'] !== ''">
                                    <img :src="hotelDetail['pic']" alt="">
                                </div>
                                <div class="hotel-info-img" v-else>
                                    <img :src="hotelDetail['dpic']" alt="">
                                    <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                                </div>
                                <div class="hotel-info-data">
                                  <div class="hotel-info-data-center">
                                      <div class="hotel-info-hotelname" v-if="language === 'zh'" :class="{'blue-txt': checkDetail.hotelid === true}">{{hotelDetail.hotelname_zh}}（{{hotelDetail.hotelname}}）</div>
                                      <div class="hotel-info-hotelname" :class="{'blue-txt': checkDetail.hotelid === true}" v-else>{{hotelDetail.hotelname}}</div>
                                      <div class="hotel-info-star">
                                        <span style="margin-right: 3px;" v-for="n in hotelDetail.star" :key="n">
                                          <img style="width:15px;height:15px;" src="/static/img/star.png">
                                        </span>
                                        <span style="margin-left: -3px;" v-if="hotelDetail.star_decimal === 1">
                                          <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                                        </span>
                                      </div>
                                      <p class="addr-text">
                                        <span style="height: 100%;margin: auto 0px;"><img src="https://res.roompai.com/static/img/account/my-hoteladdr.png" alt=""></span>
                                        <span style="margin-right:10px;" v-if="language === 'zh'">{{hotelDetail.hoteladdress_zh}}</span>
                                        <span style="margin-right:10px;" v-else>{{hotelDetail.hoteladdress}}</span>
                                      </p>
                                      <p>
                                        <img src="https://res.roompai.com/static/img/account/my-hotelphone.png" alt="">{{hotelDetail.tel}}
                                      </p>
                                      <p>
                                        <img src="https://res.roompai.com/static/img/account/my-hotelemail.png" alt="">{{hotelDetail.email}}
                                      </p>
                                  </div>
                                </div>
                            </div>
                          </el-card>
                        </template>
                      </el-skeleton>
                      <div class="clearBoth order-roominfo-clear"></div>
                      <el-skeleton animated :loading="orderLoading">
                        <template slot="template">
                          <div class="data-block order-detail">
                            <div class="order-detail-line">
                                <div class="order-detail-center">
                                    <div class="order-detail-line-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                    <div class="order-detail-line-right" v-if="ismobile === false"><el-skeleton-item variant="text" style="width: 190px;"/></div>
                                </div>
                            </div>
                            <div class="order-detail-main">
                                <div class="order-detail-center" v-if="ismobile === false">
                                    <div class="clearBoth order-roominfo-clear"></div>
                                    <div class="order-detail-main-line mobile-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 200px;"/></div>
                                    </div>

                                    <div class="order-detail-main-line">
                                      <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                      <div class="order-detail-main-right"><el-skeleton-item variant="text"/></div>
                                    </div>
                                    <div class="clearBoth order-roominfo-clear"></div>
                                </div>
                                <div class="order-detail-center" v-else>
                                    <div class="clearBoth order-roominfo-clear"></div>
                                    <div class="margin-top el-descriptions">
                                      <div class="el-descriptions__body" style=" background-color: #F5F5F6; font-size: 12px;">
                                        <table class="el-descriptions__table">
                                          <tbody>
                                            <tr style="height:50px;">
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="1">
                                                <div class="titletd"><el-skeleton-item variant="text" style="width: 70%;"/></div>
                                                <div class="infotd"><el-skeleton-item variant="text" style="width: 90%;"/></div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div class="clearBoth order-roominfo-clear"></div>
                                </div>
                            </div>
                          </div>
                        </template>
                        <template>
                          <el-card :body-style="{ padding: '0px' }">
                            <div class="data-block order-detail">
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-left">{{$t('bookingDetails')}}</div>
                                        <div class="order-detail-line-right" v-if="ismobile === false"><a v-if="language === 'en'">{{$t('creationDate')}} {{orderDetail.create_date}}</a><a v-else>{{$t('creationDate')}}{{orderDetail.create_date}}</a></div>
                                    </div>
                                </div>
                                <div class="order-detail-main">
                                    <div class="order-detail-center" v-if="ismobile === false">
                                        <div class="clearBoth order-roominfo-clear"></div>
                                        <div class="order-detail-main-line mobile-line">
                                            <div class="order-detail-main-left">{{$t('roomName')}}</div>
                                            <div class="order-detail-main-right" v-if="language === 'zh'" :class="{'blue-txt': checkDetail.roomName === true}">
                                                {{orderDetail.parent_room}}（{{orderDetail.parent_room_en}}）
                                            </div>
                                            <div class="order-detail-main-right" :class="{'blue-txt': checkDetail.roomName === true}" v-else>
                                                {{orderDetail.parent_room_en}}
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('checkInTime')}}</div>
                                            <div class="order-detail-main-right" :class="{'blue-txt': checkDetail.checkin === true}">
                                                {{orderDetail.checkin_val}} （{{orderDetail.checkin_week_val}}）
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('checkOutTime')}}</div>
                                            <div class="order-detail-main-right" :class="{'blue-txt': checkDetail.checkout === true}">
                                                {{orderDetail.checkout_val}} （{{orderDetail.checkout_week_val}}）
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('travelDates')}}</div>
                                            <div class="order-detail-main-right" :class="{'blue-txt': checkDetail.night === true}">
                                                {{orderDetail.wan}}
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('roomNumber')}}</div>
                                            <div class="order-detail-main-right">
                                                {{orderDetail.roomcount}} {{$t('between')}}
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('guest')}}</div>
                                            <div class="order-detail-main-right">
                                                <a :class="{'blue-txt': checkDetail.person === true}">{{orderDetail.adult_num}}</a> <span v-if="orderDetail.adult_num === '1'">{{$t('adult')}}</span><span v-else>{{$t('adults')}}</span>
                                                <span v-if="orderDetail.child_num !== '0'">
                                                  <span v-if="language === 'zh'">，</span>
                                                  <span v-else>, </span>
                                                  {{orderDetail.child_num}}
                                                  <span v-if="orderDetail.child_num === '1'"> {{$t('child')}}</span>
                                                  <span v-else> {{$t('children')}}</span> {{orderDetail.childOld}}
                                                </span>
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('guestName')}}</div>
                                            <div class="order-detail-main-right">
                                              <el-tooltip placement="top" effect="dark" popper-class="atooltip" class="tipinfo">
                                                <div slot="content">
                                                  <span style="display:block;" v-for="value in orderDetail.customs" :key="value">{{value}}</span>
                                                </div>
                                                <span :class="{'blue-txt': checkDetail.customer === true}">{{orderDetail.adults}}</span>
                                              </el-tooltip>
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                          <div class="order-detail-main-left">{{$t('electronEmail')}}</div>
                                          <div class="order-detail-main-right">{{orderDetail.useremail}}</div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('bedType')}}</div>
                                            <div class="order-detail-main-right" :class="{'blue-txt': checkDetail.bedType === true}">
                                                <span v-if="language === 'zh'">{{orderDetail.bedtype}}</span>
                                                <span v-else>{{orderDetail.bedtype_en}}</span>
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('breakfast')}}</div>
                                            <div class="order-detail-main-right">
                                                <span class="greenText" :class="{'blue-txt': checkDetail.breakfast === true}">
                                                  <sapn v-if="language === 'zh'">{{orderDetail.breakfastList.zh}}</sapn>
                                                  <sapn v-else> {{orderDetail.breakfastList.en}}</sapn>
                                                </span>
                                                <a v-if="orderDetail['breakfast_num'] !== '0'" :class="{'blue-txt': checkDetail.breakfast_num === true}">
                                                  <a v-if="language === 'zh'">（{{orderDetail.breakfast_num}}{{$t('breakfastnum')}}）</a>
                                                  <a v-else> ({{$t('breakfastnum')}} {{orderDetail.breakfast_num}})</a>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('cancellationPolicy')}}</div>
                                            <div class="order-detail-main-right greenText" :class="{'redText': orderDetail.cancel === '0', 'blue-txt': checkDetail.cancel === true}">
                                              <el-tooltip class="item cancel-title-data-cont" effect="dark" :content="cancelText" placement="top">
                                                <span>{{orderDetail.cancel_txt}}</span>
                                              </el-tooltip>
                                            </div>
                                        </div>

                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('specialRequests')}}</div>
                                            <div class="order-detail-main-right" :class="{'blue-txt': checkDetail.breakfast === true}">
                                                {{orderDetail.special_request}}
                                            </div>
                                        </div>
                                        <div class="clearBoth order-roominfo-clear"></div>
                                    </div>
                                    <div class="order-detail-center" v-else>
                                        <div class="clearBoth order-roominfo-clear"></div>
                                        <div class="margin-top el-descriptions">
                                          <div class="el-descriptions__body" style=" background-color: #F5F5F6; font-size: 12px;">
                                            <table class="el-descriptions__table">
                                              <tbody>
                                                <tr style="height:50px;">
                                                  <td colspan="1">
                                                    <div class="titletd">{{$t('roomName')}}</div>
                                                    <div class="infotd" :class="{'blue-txt': checkDetail.roomName === true}">
                                                      <a v-if="language === 'zh'">{{orderDetail.parent_room}}（{{orderDetail.parent_room_en}}）</a><a v-else>{{orderDetail.parent_room_en}}</a>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('checkInTime')}}</div>
                                                      <div class="infotd" :class="{'blue-txt': checkDetail.checkin === true}">{{orderDetail.checkin_val}} （{{orderDetail.checkin_week_val}}）</div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('checkOutTime')}}</div>
                                                      <div class="infotd" :class="{'blue-txt': checkDetail.checkout === true}">{{orderDetail.checkout_val}} （{{orderDetail.checkout_week_val}}）</div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                    <div class="titletd">{{$t('travelDates')}}</div>
                                                      <div class="infotd" :class="{'blue-txt': checkDetail.night === true}">{{orderDetail.wan}}</div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                    <div class="titletd">{{$t('roomNumber')}}</div>
                                                      <div class="infotd">{{orderDetail.roomcount}} {{$t('between')}}</div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('guest')}}</div>
                                                      <div class="infotd"><a :class="{'blue-txt': checkDetail.person === true}">{{orderDetail.adult_num}}</a> <a v-if="orderDetail.adult_num === '1'">{{$t('adult')}}</a><a v-else>{{$t('adults')}}</a>
                                                        <span v-if="orderDetail.child_num !== '0'">
                                                          <a v-if="language === 'zh'">，</a>
                                                          <a v-else>, </a>
                                                          {{orderDetail.child_num}}
                                                          <a v-if="orderDetail.child_num === '1'"> {{$t('child')}}</a>
                                                          <a v-else> {{$t('children')}}</a> {{orderDetail.childOld}}
                                                        </span>
                                                      </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('guestName')}}</div>
                                                      <div class="infotd" :class="{'blue-txt': checkDetail.customer === true}">
                                                        <a style="display:block;" v-for="value in orderDetail.customs" :key="value">{{value}}</a>
                                                      </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('electronEmail')}}</div>
                                                      <div class="infotd">{{orderDetail.useremail}}</div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('bedType')}}</div>
                                                      <div class="infotd" :class="{'blue-txt': checkDetail.bedType === true}">
                                                        <a v-if="language === 'zh'">{{orderDetail.bedtype}}</a>
                                                        <a v-else>{{orderDetail.bedtype_en}}</a>
                                                      </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('breakfast')}}</div>
                                                      <div class="infotd">
                                                        <a class="greenText" :class="{'blue-txt': checkDetail.breakfast === true}">
                                                          <sapn v-if="language === 'zh'">{{orderDetail.breakfastList.zh}}</sapn>
                                                          <sapn v-else> {{orderDetail.breakfastList.en}}</sapn>
                                                        </a>
                                                        <a v-if="orderDetail['breakfast_num'] !== '0'" :class="{'blue-txt': checkDetail.breakfast_num === true}">
                                                          <a v-if="language === 'zh'">（{{orderDetail.breakfast_num}}{{$t('breakfastnum')}}）</a>
                                                          <a v-else> ({{$t('breakfastnum')}} {{orderDetail.breakfast_num}})</a>
                                                        </a>
                                                      </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('cancellationPolicy')}}</div>
                                                      <div class="infotd greenText" :class="{'redText': orderDetail.cancel === '0', 'blue-txt': checkDetail.cancel === true}">{{orderDetail.cancel_txt}}<span><img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" @click="cancelDiaShow = true"></span>
                                                        <el-dialog :visible.sync="cancelDiaShow" width="80%" :show-close="cancelShowClose" class="tax-margin" top="35vh">
                                                          <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">{{$t('cancellationPolicy')}}</div>
                                                          <div style="font-size: 12px; color: #303133; text-align: center; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                                                            <span>{{cancelText}}</span>
                                                          </div>
                                                          <div @click="cancelDiaShow = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">{{$t('close')}}</div>
                                                        </el-dialog>
                                                      </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td colspan="1">
                                                      <div class="titletd">{{$t('specialRequests')}}</div>
                                                      <div class="infotd greenText" :class="{'blue-txt': checkDetail.breakfast === true}">{{orderDetail.special_request}}</div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                        <div class="clearBoth order-roominfo-clear"></div>
                                    </div>
                                </div>
                                <div class="order-detail-line">
                                    <div class="order-detail-center" v-if="ismobile === false && orderDetail.order_status === '4'">
                                        <div class="order-detail-line-left"></div>
                                        <div class="order-detail-line-right" style="color:#66B1FF;">{{$t('cancellationDateTime')}}：{{orderDetail.cancel_date}}</div>
                                    </div>
                                </div>
                            </div>
                          </el-card>
                        </template>
                      </el-skeleton>
                      <div class="clearBoth order-roominfo-clear"></div>
                      <el-skeleton animated :loading="priceLoading">
                        <template slot="template">
                          <div class="detail-two">
                            <div class="data-block price-detail detail-data" :class="{'float-right': floatRight}">
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-all"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                    </div>
                                </div>

                                <div class="order-detail-main">
                                    <div class="order-detail-center">
                                        <div class="clearBoth order-roominfo-clear"></div>
                                        <div class="order-detail-main-line main-line-maxheight">
                                            <div class="order-detail-main-left" style="width:60%;">
                                              <el-skeleton-item variant="text" style="width: 100px;"/>
                                              <br>
                                              <el-skeleton-item variant="text" style="width: 135px;"/>
                                            </div>
                                            <div class="order-detail-main-right" style="width:40%;"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                        </div>
                                        <div class="order-detail-main-line">
                                          <div class="order-detail-main-left" style="width:60%;"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                          <div class="order-detail-main-right" style="width:40%;"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                        </div>
                                        <div class="clearBoth order-roominfo-clear"></div>
                                    </div>
                                </div>
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-left"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                        <div class="order-detail-line-right"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                    </div>
                                </div>
                            </div>
                            <div class="data-block email-detail detail-data" v-if="orderDetail.order_status === '4'">
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-all"><el-skeleton-item variant="text" style="width: 135px;"/></div>
                                    </div>
                                </div>
                                <div class="order-detail-main">
                                    <div class="order-detail-center">
                                        <div class="clearBoth order-roominfo-clear"></div>
                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                            <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                        </div>
                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                            <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                        </div>
                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                            <div class="order-detail-main-right"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-left"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                        <div class="order-detail-line-right"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </template>
                        <template>
                          <div class="detail-two">
                            <div class="data-block price-detail detail-data" :class="{'float-right': floatRight}">
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-all">{{$t('priceDetails')}}</div>
                                    </div>
                                </div>

                                <div class="order-detail-main" ref="divName">
                                    <div class="order-detail-center">
                                        <div class="clearBoth order-roominfo-clear"></div>
                                        <div class="order-detail-main-line main-line-maxheight" :class="{'main-line-maxheight-two':orderDetail.additionalChargeprice !== '' && orderDetail.additionalChargeprice !== 0}">
                                            <div class="order-detail-main-left" style="width:60%;">
                                                <span v-if="language === 'zh'">{{orderDetail.roomcount}}{{$t('onOurSite')}} x {{orderDetail.wan}}{{$t('night')}}</span>
                                                <span v-else>{{orderDetail.roomcount}} {{$t('onOurSite')}}<span v-if="orderDetail.roomcount !=='1'">s</span> x {{orderDetail.wan}} {{$t('night')}}<span v-if="orderDetail.wan !=='1'">s</span></span>
                                                <br>
                                                <span>{{$t('avgNight')}} {{orderDetail.unitprice_new}}</span>
                                            </div>
                                            <div class="order-detail-main-right" style="width:40%;">
                                                {{orderDetail.unitprice_all}}
                                            </div>
                                        </div>
                                        <div class="order-detail-main-line main-line-maxheight-two" style="color:#5392F9;" v-if="orderDetail.additionalChargeprice !== '' && orderDetail.additionalChargeprice !== 0">
                                            <div class="order-detail-main-left" style="width:60%;">{{$t('additionalCharge')}}</div>
                                            <div class="order-detail-main-right" style="width:40%;">{{orderDetail.additionalCharge}}</div>
                                        </div>
                                        <div class="order-detail-main-line">
                                          <div class="order-detail-main-left" style="width:60%;">{{$t('taxesFees')}}
                                            <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" @click="taxDia = true">
                                            <el-dialog :visible.sync="taxDia" :width="diaWidth" :show-close="taxShowClose" class="tax-margin" top="35vh">
                                              <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">
                                                {{$t('taxesFees')}}
                                              </div>
                                              <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px -5px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('taxesAndServiceFees')}}</div>
                                              <div @click="taxDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;margin: 20px -5px -30px -5px;">
                                                {{$t('close')}}
                                              </div>
                                            </el-dialog>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                              {{orderDetail.tax_new}}
                                          </div>
                                        </div>
                                        <!-- 交易费 -->
                                        <div class="order-detail-main-line main-line-maxheight-two" v-if="orderDetail.transaction_fee !== '' && orderDetail.transaction_fee !== 0 && orderDetail.transaction_fee !== '0'">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('TransactionFee')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.transaction_fee_new}}
                                          </div>
                                        </div>
                                        <!-- payableAtProperty -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.mandatoryFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('mandatoryFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.mandatoryFee}}
                                          </div>
                                        </div>
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.mandatoryTax !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('mandatoryTax')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.mandatoryTax}}
                                          </div>
                                        </div>
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.resortFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('resortFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.resortFee}}
                                          </div>
                                        </div>
                                        <!-- 清洁费用等 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.cityFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('cityTaxFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.cityFee}}
                                          </div>
                                        </div>
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.destinationFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('destinationFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.destinationFee}}
                                          </div>
                                        </div>
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.serviceFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('serviceFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.serviceFee}}
                                          </div>
                                        </div>
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.cleaningFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('cleaningFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.cleaningFee}}
                                          </div>
                                        </div>
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.administrativeFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('administrativeFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.administrativeFee}}
                                          </div>
                                        </div>
                                        <!-- 婴儿床费等强制费预付费用 开始 -->
                                        <!-- 婴儿床费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.cribFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('cribFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.cribFee}}
                                          </div>
                                        </div>
                                        <!-- 维护费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.maintenanceFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('maintenanceFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.maintenanceFee}}
                                          </div>
                                        </div>
                                        <!-- 杂费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.miscellaneousFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('miscellaneousFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.miscellaneousFee}}
                                          </div>
                                        </div>
                                        <!-- 其他费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.otherFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('otherFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.otherFee}}
                                          </div>
                                        </div>
                                        <!-- 套餐费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.packageFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('packageFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.packageFee}}
                                          </div>
                                        </div>
                                        <!-- 宠物卫生费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.petSanitationFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('petSanitationFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.petSanitationFee}}
                                          </div>
                                        </div>
                                        <!-- 加床费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.rollawayFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('rollawayFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.rollawayFee}}
                                          </div>
                                        </div>
                                        <!-- 客房服务费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.roomServiceFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('roomServiceFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.roomServiceFee}}
                                          </div>
                                        </div>
                                        <!-- 附加费 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.surchargeFee !== ''">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('surchargeFee')}}</span>
                                            <span class="avgprice" v-if="payAtHotel === true">{{$t('payableAtProperty')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.surchargeFee}}
                                          </div>
                                        </div>
                                        <!-- 婴儿床费等强制费预付费用 结束 -->
                                        <div class="order-detail-main-line" :class="{'main-line-maxheight-two': payAtHotel === true}" v-if="orderDetail.discount_price !== '0' && orderDetail.discount_price !== 0">
                                          <div class="order-detail-main-left" style="width:60%;">
                                            <span>{{$t('coupon')}}</span>
                                          </div>
                                          <div class="order-detail-main-right" style="width:40%;">
                                            {{orderDetail.discountPrice}}
                                          </div>
                                        </div>
                                        <div class="clearBoth order-roominfo-clear"></div>
                                    </div>
                                </div>
                                <div class="order-detail-line" ref="payDiv">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-left">{{$t('totalPrice')}}</div>
                                        <div class="order-detail-line-right" v-if="checkDetail.totalprice === false">{{orderDetail.totalprice_new}}</div>
                                        <div class="order-detail-line-right blue-txt" v-else>{{orderDetail.childtotalprice_new}}</div>
                                    </div>
                                    <div class="order-detail-center" style="height:40px;" v-if="orderDetail.surcharge_money !== '' && payAtHotel === true">
                                        <div class="order-detail-line-left-sur">{{$t('payNow')}}</div>
                                        <div class="order-detail-line-right-sur" v-if="checkDetail.totalprice === false">{{orderDetail.payprice_new}}</div>
                                        <div class="order-detail-line-right-sur blue-txt" v-else>{{orderDetail.childpayprice_new}}</div>
                                    </div>
                                    <div class="order-detail-center" style="height:40px;" v-if="orderDetail.surcharge_money !== '' && payAtHotel === true">
                                        <div class="order-detail-line-left-sur">{{$t('payableAtProperty')}}</div>
                                        <div class="order-detail-line-right-sur">{{orderDetail.surcharge_money_new}}</div>
                                    </div>
                                    <div class="order-detail-center" :class="'order-detail-center-pricemsg-'+language" v-if="orderDetail.surcharge_money !== ''">
                                        <div class="order-detail-line-left-sur-mess">{{$t('priceDetailMsg')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="data-block email-detail detail-data" v-if="orderDetail.order_status === '4'">
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-all">{{$t('paymentDetails')}}</div>
                                    </div>
                                </div>
                                <div class="order-detail-main" :style="{ height: `${priceHeight}px`}">
                                    <div class="order-detail-center">
                                        <div class="clearBoth order-roominfo-clear"></div>
                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('paymentMethods')}}</div>
                                            <div class="order-detail-main-right">
                                              <span v-if="orderDetail.cardtype==='1'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/visa.png" /></span>
                                              <span v-else-if="orderDetail.cardtype==='2'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/mastercard.png" /></span>
                                              <span v-else-if="orderDetail.cardtype==='6'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/paypal.png" /></span>
                                              <span v-else-if="orderDetail.cardtype==='8'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/debit-card.png" /></span>
                                              <span v-else>{{orderDetail.cardTypeText}}</span>
                                            </div>
                                        </div>
                                        <div class="order-detail-main-line" >
                                            <div class="order-detail-main-left" v-if="orderDetail.cardtype==='1' || orderDetail.cardtype==='2'">{{$t('payAccount')}}</div>
                                            <div class="order-detail-main-right" v-if="orderDetail.cardtype==='1' || orderDetail.cardtype==='2'">
                                              {{orderDetail.cardno}}
                                            </div>
                                        </div>
                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('paymentAmounts')}}</div>
                                            <div class="order-detail-main-right" v-if="orderDetail.surcharge_money !== '' && payAtHotel === true">
                                                {{orderDetail.cancel_payprice_new}}
                                            </div>
                                            <div class="order-detail-main-right" v-else>
                                                {{orderDetail.cancel_totalprice_new}}
                                            </div>
                                        </div>
                                        <div class="order-detail-main-line">
                                            <div class="order-detail-main-left">{{$t('cancellationCharges')}}</div>
                                            <div class="order-detail-main-right">
                                                {{orderDetail.cancel_price}}
                                            </div>
                                        </div>
                                        <!-- <div class="clearBoth order-roominfo-clear"></div> -->
                                    </div>
                                </div>
                                <div class="order-detail-line" :style="{ height: `${payHeight}px`}">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-left">{{$t('refund')}}</div>
                                        <div class="order-detail-line-right">{{orderDetail.refund_price}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="data-block email-detail detail-data" v-else-if="orderDetail.order_status === '2' || orderDetail.order_status === '3' || orderDetail.order_status === '6'">
                                <div class="order-detail-line">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-all">{{$t('payDetail')}}</div>
                                    </div>
                                </div>
                                <div class="order-detail-main" :style="{ height: `${priceHeight}px`}">
                                    <div class="order-detail-center">
                                        <div class="clearBoth order-roominfo-clear"></div>
                                        <div class="order-detail-main-line-con">
                                            <div class="order-detail-main-left">{{$t('paymentMethods')}}</div>
                                            <div class="order-detail-main-right">
                                              <span v-if="orderDetail.cardtype==='1'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/visa.png" /></span>
                                              <span v-else-if="orderDetail.cardtype==='2'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/mastercard.png" /></span>
                                              <span v-else-if="orderDetail.cardtype==='6'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/paypal.png" /></span>
                                              <span v-else-if="orderDetail.cardtype==='8'"><img style="width:38px;height:25px;" src="https://res.roompai.com/static/img/order/debit-card.png" /></span>
                                              <span v-else>{{orderDetail.cardTypeText}}</span>
                                            </div>
                                        </div>
                                        <div class="order-detail-main-line" v-if="orderDetail.cardtype==='1' || orderDetail.cardtype==='2'">
                                            <div class="order-detail-main-left">{{$t('payAccount')}}</div>
                                            <div class="order-detail-main-right">
                                              {{orderDetail.cardno}}
                                            </div>
                                        </div>
                                        <!-- <div class="clearBoth order-roominfo-clear"></div> -->
                                    </div>
                                </div>
                                <div class="order-detail-line" :style="{ height: `${payHeight}px`}">
                                    <div class="order-detail-center">
                                        <div class="order-detail-line-left">{{$t('amounts')}}</div>
                                        <div class="order-detail-line-right" v-if="orderDetail.surcharge_money !== '' && payAtHotel === true">{{orderDetail.payprice_new}}</div>
                                        <div class="order-detail-line-right" v-else>{{orderDetail.totalprice_new}}</div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </template>
                        </el-skeleton>
                      <div class="clearBoth order-roominfo-clear"></div>
                      <!--订房须知-->
                      <div v-show='noticeShow'>
                        <div class="room-order-tips" v-if="ismobile === false">
                          <div class="room-order-tips-top">{{$t('bookingNotice')}}</div>
                          <div class="room-order-tips-info" v-html="orderDetail.surcharge_txt_zh" v-if="language === 'zh'"></div>
                          <div class="room-order-tips-info" v-html="orderDetail.surcharge_txt_en" v-else></div>
                        </div>
                        <div class="room-order-tips" @click="bookingNoticeShow = !bookingNoticeShow" v-else>
                          <div :class="{'room-order-tip-shadow': bookingNoticeShow === true}">
                            <div class="room-order-tips-top">
                              <div style="float:left;">{{$t('bookingNotice')}}</div>
                              <div style="float:right">
                                <img style=" width: 12px;height: 12px; margin-top: 19px;" src="/static/img/hotelsearch/drop-down.png" alt="" v-if="bookingNoticeShow === false">
                                <img style=" width: 12px;height: 12px; margin-top: 19px;" src="/static/img/hotelsearch/drop-up.png" alt="" v-else>
                              </div>
                            </div>
                          </div>
                          <div v-if="bookingNoticeShow === true">
                            <div class="room-order-tips-info" v-html="orderDetail.surcharge_txt_zh" v-if="language === 'zh'"></div>
                            <div class="room-order-tips-info" v-html="orderDetail.surcharge_txt_en" v-else></div>
                          </div>
                        </div>
                        <div class="clearBoth order-roominfo-clear"></div>
                      </div>
                      <!--特别入住说明-->
                      <div v-show='orderDetail.special_instructions_en && orderDetail.special_instructions_en !== ""'>
                        <div class="room-order-tips" v-if="ismobile === false">
                          <div class="room-order-tips-top">{{$t('specialCheckinInstructions')}}</div>
                          <div class="room-order-tips-info" v-html="orderDetail.special_instructions_zh" v-if="language === 'zh'"></div>
                          <div class="room-order-tips-info" v-html="orderDetail.special_instructions_en" v-else></div>
                        </div>
                        <div class="room-order-tips" @click="specialInstructionsShow = !specialInstructionsShow" v-else>
                          <div :class="{'room-order-tip-shadow': specialInstructionsShow === true}">
                            <div class="room-order-tips-top" style="margin: 0 10px">
                              <div style="float:left;">{{$t('specialCheckinInstructions')}}</div>
                              <div style="float:right">
                                <img style=" width: 12px;height: 12px; margin-top: 19px;" src="/static/img/hotelsearch/drop-down.png" alt="" v-if="specialInstructionsShow === false">
                                <img style=" width: 12px;height: 12px; margin-top: 19px;" src="/static/img/hotelsearch/drop-up.png" alt="" v-else>
                              </div>
                            </div>
                          </div>
                          <div v-if="specialInstructionsShow === true" style="margin-top: 10px;">
                            <div class="room-order-tips-info" style="margin: 0 10px" v-html="orderDetail.special_instructions_zh" v-if="language === 'zh'"></div>
                            <div class="room-order-tips-info" style="margin: 0 10px" v-html="orderDetail.special_instructions_en" v-else></div>
                          </div>
                        </div>
                        <div class="clearBoth order-roominfo-clear"></div>
                      </div>
                      <div v-if="orderDetail.cancel_reason !== '6'">
                        <div class="tips-detail" v-if="orderDetail.order_status === '2' || orderDetail.order_status === '3' || orderDetail.order_status === '6'">
                            <div class="data-block tips-one" v-show="confirmMessShow">
                                <div class="back-gray">
                                  <img style="width:18px;height:18px;margin-top: 4.8px;margin-left: 4.5px;" src="https://res.roompai.com/static/img/account/my-email.png" alt="">
                                </div>
                                <span class='email-text' v-html="$t('bookingConfirmationHasBeenSend')"></span>
                                <img src="https://res.roompai.com/static/img/account/del.png" v-if="ismobile === false" style="width:28px; height: 28px;cursor: pointer;margin: 0px 15px;" @click="confirmMessShow=false" />
                            </div>
                        </div>
                        <div class="tips-detail" v-else-if="orderDetail.order_status === '4'">
                            <div class="data-block tips-one">
                              <div class="back-gray">
                                <img style="width:18px;height:18px;margin:5px;" src="https://res.roompai.com/static/img/account/my-cancel.png" alt="">
                              </div>
                              <div style="margin-right:20px" v-if="(orderDetail.refund_money !== 0)">{{$t('yourCardOrAccountShouldReceiveRefundAmountLeft')}} {{orderDetail.refund_price}} {{$t('yourCardOrAccountShouldReceiveRefundAmountRight')}}</div>
                              <div style="margin-right:20px" v-else>{{$t('noCancelMsg')}} {{$t('norefundContactUs')}}</div>
                            </div>
                        </div>
                        <div class="clearBoth order-roominfo-clear"></div>
                        <div class="tips-detail">
                          <div class="data-block tips-one" v-show="sendPdfEmail">
                            <div class="back-gray">
                              <img style="width:18px;height:18px;margin:5px;" src="https://res.roompai.com/static/img/account/my-email.png" alt="">
                            </div>
                            <div style="margin-right:20px">
                              {{$t('emailMsgLeft')}} {{sendEmail}} {{$t('emailMsgRight')}}
                            </div>
                          </div>
                        </div>
                        <!--按钮-->
                        <div class="button-detail" v-if="orderDetail.order_status === '1'">
                            <router-link :to="{name:'contactUs', params: {'querys': common.linkEncode({ orderno: orderDetail.orderno, 'source': source, 'conver': conver }, 'obj')}}">
                              <button class="button-pay">{{$t('goToPay')}}</button>
                            </router-link>
                        </div>
                        <div class="button-detail" v-else-if="orderDetail.order_status === '2'">
                            <router-link :to="{name:'contactUs', params: {'querys': common.linkEncode({ orderno: orderDetail.orderno, 'source': source, 'conver': conver }, 'obj')}}">
                              <button class="button-contact">{{$t('contactGus')}}</button>
                            </router-link>
                            <button v-if="check === true" class="button-cancel" @click="openCancelDia()">{{$t('cancel')}}</button>
                            <button v-else class="button-cancel-none">{{$t('cancel')}}</button>
                        </div>
                        <div class="button-detail" v-else-if="orderDetail.order_status === '3' || orderDetail.order_status === '6'">
                          <div v-if="orderDetail.child_order_status !== 1 && orderDetail.child_order_status !== '1'">
                            <button class="button-report" @click="downloadPdf" v-show="reportShow">{{$t('sendVoucher')}}</button>
                            <button class="button-report-no" v-show="reportNoShow">{{$t('sendVoucher')}}</button>
                            <router-link :to="{name:'contactUs', params: {'querys': common.linkEncode({ orderno: orderDetail.orderno, 'source': source, 'conver': conver }, 'obj')}}">
                              <button class="button-contact">{{$t('contactGus')}}</button>
                            </router-link>
                            <button class="button-cancel" :class="{'gray-color':grayColor}" @click="openCancelDia()" v-if="orderDetail.com_cancel === true">{{$t('cancel')}}</button>
                            <button class="button-cancel-none" v-else>{{$t('cancel')}}</button>
                          </div>
                          <div v-else>
                            <router-link :to="{name:'WriteChildPay', params: {'querys': common.linkEncode({ orderno: orderDetail.orderno, 'source': source, 'conver': conver }, 'obj')}}">
                              <button class="button-pay">{{$t('goToPay')}} {{ orderDetail.childprice }}</button>
                            </router-link>
                          </div>
                        </div>
                        <div class="button-detail" v-else>
                            <!-- <button class="button-report" @click="downloadPdf" v-show="reportShow">{{$t('sendVoucher')}}</button> -->
                            <button class="button-report-no">{{$t('sendVoucher')}}</button>
                            <router-link :to="{name:'contactUs', params: {'querys': common.linkEncode({ orderno: orderDetail.orderno, 'source': source, 'conver': conver }, 'obj')}}">
                              <button class="button-contact">{{$t('contactGus')}}</button>
                            </router-link>
                            <button class="button-cancel-none">{{$t('cancel')}}</button>
                        </div>
                        <div class="clearBoth order-roominfo-clear"></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </el-main>
  <div class="clearBoth"></div>
  <publicFooter></publicFooter>
  <!--取消订单-->
  <el-dialog class="open-dia" title="" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :show-close="showClo" :visible.sync="openCancel" :width="diaWidth">
    <div slot="title" style="font-size: 20px; font-weight: 650;color:#333333;">{{$t('cancel')}}</div>
    <div class="dia-content">
      <div style="height: 50px;line-height: 50px;">{{$t('orderCancelReason')}}<span style="color:red;">*</span></div>
      <div class="el-form-item__content">
        <el-select v-model="reason" @focus="setOptionWidth" style="width:100%" @change="reasonChange" v-if="language === 'zh'">
          <el-option v-for="(item, id) in reasons" :key="item" :style="{ width: `${selectOptionWidth}px` }" :label="item" :value="id" :class="{'mobile-select': ismobile}">
          </el-option>
        </el-select>
        <el-select v-model="reason" @focus="setOptionWidth" style="width:100%" @change="reasonChange" v-else>
          <el-option v-for="(item, id) in reasonsEn" :key="item" :style="{ width: `${selectOptionWidth}px` }" :label="item" :value="id" :class="{'mobile-select': ismobile, 'twoline': ismobile && (id === 4 || id === '4')}">
          <span>{{item}}</span>
        </el-option>
      </el-select>
      </div>
      <div style="color:red; margin-top:10px;" v-show="reasonMust">{{$t('selectCancelReason')}}</div>
      <div class="el-input" :class="{'otherreason-msg': otherReasonMsg}" style="margin-top:8px;" v-show="otherReason">
        <input type="text" ref="otherreason" autocomplete="off" class="el-input__inner">
      </div>
    </div>
    <div style="padding:30px 20px;">
      <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('nowCancelRefund')}} <span style="color:red;">{{refundDetail.cancelprice_val}}</span><a v-if="language === 'zh'">。</a><a v-else>.</a></div>
      <div class="dia-price">
        <div>
          <span style="width:60%; float:left;">{{$t('orderPrice')}}</span><span style="width:40%; float:right; text-align: right;">{{refundDetail.totalprice_val}}</span>
        </div>
        <div>
          <span style="width:60%; float:left;">{{$t('cancelPrice')}}</span><span style="width:40%; float:right; text-align: right;">{{refundDetail.cancelprice_val}}</span>
        </div>
      </div>
      <div style="font-weight:600;">
        <span style="width:40%; float:left;">{{$t('refundPrice')}}</span><span style="width:40%; float:right; text-align: right;">{{refundDetail.refundprice_val}}</span>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="dialog-close" @click="closeCancel('first_cancel')">{{$t('close')}}</el-button>
      <el-button class="dialog-cancel" type="primary" @click="cancelContinue">{{$t('continueCancel')}}</el-button>
    </div>
</el-dialog>
<!--继续取消-->
<el-dialog class="open-dia" title="" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :show-close="showClo" :visible.sync="cancelContinueDia" :width="diaWidth">
    <div slot="title" style="font-size: 20px; font-weight: 650;color:#333333;">{{$t('cancel')}}</div>
    <div class="dia-content-continue">
      <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('canNotCancelLeft')}} <span style="color:red;"><br v-if="ismobile === false">{{refundDetail.cancelprice_val}}</span> {{$t('canNotCancelRight')}}</div>
      <div style="margin-top: 30px;">{{$t('isContinueCancel')}}</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="dialog-close"  @click="closeCancel('continue_cancel')">{{$t('close')}}</el-button>
      <el-button class="dialog-cancel" type="primary" @click="doCancel">{{$t('continueCancel')}}</el-button>
    </div>
</el-dialog>
<!--取消订单成功-可退款-->
<el-dialog class="dia-success" title="" :close-on-press-escape="showClo" :show-close="showClo" @close="refreshUrl" :visible.sync="cancelSuccess" :width="diaWidth">
    <div style="text-align:center;">
      <div class="order-status-img" style="width:70px;height:70px;background:#34C447;border-radius: 50%; margin:0 auto;">
          <img style="width:30px; height:30px;margin: 20px;" src="https://res.roompai.com/static/img/account/my-payment-yes.png">
      </div>
      <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
        <div style="margin:25px 0px; font-size: 18px;">{{$t('orderCancelSuccess')}}</div>
        <div class="cancelmsg-text" style="text-align:left;padding:1 20px 20px 20px">{{$t('yourCardOrAccountShouldReceiveRefundAmountLeft')}}&nbsp;{{refundDetail.refundprice_val}}&nbsp;{{$t('yourCardOrAccountShouldReceiveRefundAmountRightTwo')}}&nbsp;{{$t('willRefundTime')}}&nbsp;{{$t('contactBank')}}</div>
      </div>
    </div>
</el-dialog>
<!--取消订单成功-不可退款-->
<el-dialog class="dia-success" title="" :close-on-press-escape="showClo" :show-close="showClo" @close="refreshUrl" :visible.sync="cancelSuccessNoRefund" :width="diaWidth">
    <div style="text-align:center;">
      <div class="order-status-img" style="width:70px;height:70px;background:#34C447;border-radius: 50%; margin:0 auto;">
          <img style="width:30px; height:30px;margin: 20px;" src="https://res.roompai.com/static/img/account/my-payment-yes.png">
      </div>
      <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
        <div style="margin:25px 0px; font-size: 18px;">
          {{$t('orderCancelSuccess')}}
        </div>
        <div class="cancelmsg-text"  style="text-align: left;padding:0 20px 20px 20px">{{$t('noCancelMsg')}} {{$t('norefundContactUs')}}</div>
      </div>
    </div>
</el-dialog>
<!--取消订单失败-->
<el-dialog class="dia-success" title="" :close-on-press-escape="showClo" :show-close="showClo" @close="refreshUrl" :visible.sync="cancelFailed" :width="diaWidth">
    <div style="text-align:center;">
      <div class="order-status-img" style="width:70px;height:70px;background:red;border-radius: 50%; margin:0 auto;">
          <img style="width:40px; height:40px;margin: 15px;" src="https://res.roompai.com/static/img/account/my-error.png">
      </div>
      <div stype="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
        <div style="margin:25px 0px; font-size: 18px;">
          {{$t('orderCancelfaild')}}
        </div>
        <div class="cancelmsg-text">
          {{$t('contactCustomer')}}
        </div>
        <div class="cancelmsg-text">
          {{$t('contactEmail')}}<span v-if="language === 'en'"> </span>{{customerEmail}}
        </div>
        <div class="cancelmsg-text">
          {{$t('internationalCall')}}<span v-if="language === 'zh'">：</span><span v-else>: </span>{{phoneInternal}}
        </div>
        <div class="cancelmsg-text">
          {{$t('domesticCall')}}<span v-if="language === 'zh'">：</span><span v-else>: </span>{{phoneExternal}}
        </div>
      </div>
    </div>
</el-dialog>
<!--行程单-->
<!-- <div hidden>
  <div class="pdf" id="pdfDom" ref="pdfDom">
    <div class="pdf-main">
      <div style="padding:10px 20px;">
        <div style="width: 1040px;height: 53px;">
          <div style="display: inline-block; height: 53px;float: left;width:790px;">
            <img class="pdf-logo" src="/static/img/pdf-logo.jpg" />
          </div>
          <div class="logo-text">Booking Confirmation</div>
        </div>
        <div role="progressbar" aria-valuenow="4" aria-valuemin="0" aria-valuemax="5" class="el-progress el-progress--line is-exception">
          <div class="score-bar">
            <div class="scoreNo" style="height: 7px;">
              <div class="scoreYes" style="width: 90%;">
              </div>
            </div>
          </div>
        </div>
        <div class="pdf-content">
            <div class="pdf-title">Booking Information</div>
            <div class="pdf-information" :class="{'pdf-information-top': id === 'Booking reference'}" v-for="(item, id) in tripPdfInformation" :key="id">
              <div class="information-left">{{id}}:</div>
              <div class="information-right">{{item}}</div>
            </div>
        </div>
        <div class="pdf-content">
            <div class="pdf-title">Services provided</div>
            <div style="margin-top: 10px;font-weight: 400;font-size: 14px;width:1040px;line-height: 28px;">
            <table cellpadding='0' cellspacing='2' border='0' style="width:100%;">
                <tbody>
                <tr class="tr border-tr">
                    <td style="width:10%;">Check-in</td>
                    <td style="width:10%;">Check-out</td>
                    <td style="width:8%;">Room</td>
                    <td style="width:41%;">Room type</td>
                    <td style="width:15%;">Board</td>
                    <td style="width:8%;">Adults</td>
                    <td style="width:8%;">Children</td>
                </tr>
                <tr><td colspan="7" style=" margin:2px;border-bottom: 0.5px solid rgba(215, 215, 215, 1);"></td></tr>
                <tr class="tr">
                    <td style="width:10%;">{{orderDetail.checkin_val}}</td>
                    <td style="width:10%;">{{orderDetail.checkout_val}}</td>
                    <td style="width:8%;">{{orderDetail.roomcount}}</td>
                    <td style="width:40%; padding-right:1%;">{{orderDetail.parent_room_en}}</td>
                    <td style="width:15%;">{{orderDetail.board}}</td>
                    <td style="width:8%;">{{orderDetail.adult_num}}</td>
                    <td style="width:8%;">{{orderDetail.child_num}}</td>
                </tr>
                </tbody>
            </table>
          </div>
        </div>
        <div class="pdf-content" style="height:150px;">
          <div class="pdf-title">Payment details</div>
          <div class="pdf-payment pdf-information-top">
            <div class="pdf-payment-info">
              <div class="payment-left">Room price ({{orderDetail.roomcount}} room x {{orderDetail.wan}} night )</div>
              <div class="payment-right">{{orderDetail.unitprice_all}}</div>
            </div>
            <div class="pdf-payment-info">
              <div class="payment-left">Taxes & fees </div>
              <div class="payment-right">{{orderDetail.tax_new}}</div>
            </div>
            <div class="pdf-payment-info"></div>
            <div class="pdf-payment-info">
              <div class="payment-left">Final price</div>
              <div class="payment-right">{{orderDetail.totalprice_new}}</div>
            </div>
          </div>
        </div>
        <div class="pdf-content" style="height:130px; margin-top:25px;">
            <div class="pdf-title">Cancellation policy</div>
            <div class="pdf-information pdf-policy">
              <div class="pdf-policy-text" v-if="orderDetail.cancel === '1'">Free cancellation before {{orderDetail.free_cancel_date_pdf}}  (Hotel's Local Time)</div>
              <div class="pdf-policy-text" v-else>This booking is non refundable. There will be no refund if you cancel it.</div>
              <div class="policy-remarks">
                <div>Remarks:</div>
                <div>If you fail to arrive or cancel the booking after check-in date, no refund will be given.</div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="pdf-main">
      <div style="padding:10px 20px;">
        <div class="pdf-content" style="margin:0;">
          <div class="pdf-title">Contact us</div>
          <div class="pdf-payment pdf-information-top" style="height:100px;">
            <div class="pdf-policy-text">Customer service phone number</div>
            <div class="pdf-policy-text" style="font-weight:100;">
              <span style="width:48%; float:left;">0411-84949537</span>
              <span style="width:48%; float:left;">(For domestic call)</span>
              </div>
            <div class="pdf-policy-text" style="font-weight:100;">
              <span style="width:48%; float:left;">0086-411-84949537</span>
              <span style="width:48%; float:left;">(For international call)</span>
            </div>
          </div>
          <div class="pdf-contact-right pdf-information-top" style="height:100px;">
            <div class="pdf-policy-text">Customer service email</div>
            <div class="pdf-policy-text" style="font-weight:100;">cs_client@51smart.com</div>
          </div>
          <div class="policy-remarks" style="clear:both;">
            <div>Remarks:</div>
            <div>You can always contact us if you come across any problems.</div>
          </div>
        </div>
        <div class="pdf-content pdf-notice">
          <div class="pdf-title">Important notice</div>
          <div>
            1. The price shown above DOES NOT include any applicable hotel service fees, charges for optional incidentals (such as minibar snacks or telephone calls), or regulatory surcharges. The hotel will assess these fees, charges, and surcharges upon check-out.
          </div>
          <div>
            2. The property will keep the room for you till check in date. If you fail to arrive before that day, your room might be get back by the property.
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
</el-container>
</template>

<script>
import { getTripTime, getTripDetail, getCancelPriceDetail, orderCancel, downloadTrip } from '@/request/order.js'
import { getContactInfo } from '@/request/question.js'
// import html2pdf from 'html2pdf.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicAccountMenu from '@/components/public/publicAccountMenu'
export default {
  name: 'tripDetail',
  components: {
    publicFooter,
    publicHeader,
    publicAccountMenu
  },
  data () {
    return {
      curPageData: 'TripDetail',
      orderno: '',
      cancelShow: false,
      confirmShow: false,
      noConfirmShow: false,
      paymentShow: false,
      childPaymentShow: false,
      confirmMessShow: true,
      openCancel: false,
      cancelContinueDia: false,
      reasonMust: false,
      otherReason: false,
      showClo: false,
      otherReasonMsg: false,
      cancelSuccess: false,
      cancelSuccessNoRefund: false,
      cancelFailed: false,
      grayColor: false,
      floatRight: false,
      cancelMessShow: false,
      reportShow: false,
      reportNoShow: true,
      minute: '',
      second: '',
      remainTime: 0,
      minuteString: '',
      secondString: '',
      currency: this.common.currencySet(this),
      language: this.common.languageSet(this),
      hotelDetail: [],
      orderDetail: [],
      refundDetail: [],
      checkDetail: [],
      reason: '',
      reasons: {'1': '被迫取消或延期行程', '2': '在网络上查询到更便宜的酒店价格', '3': '将与酒店直接预订', '4': '预订信息填写有误，希望取消重订', '5': '网站无法确认', '50': '其它'},
      reasonsEn: {'1': 'Forced to cancel or postpone trip', '2': 'Found lower price on the internet', '3': 'Will book with hotel directly', '4': 'Will rebook because of wrong booking information submitted', 5: 'The website is unable to confirm', '50': 'Other'},
      is_cancel: false,
      orderstatus: '',
      refreshDetailTime: 5,
      exportPDFtitle: this.common.linkQuerys.orderno,
      tripPdfInformation: {},
      currencyShow: false, // 币种是否显示
      ismobile: false,
      taxDia: false,
      cancelDia: false,
      taxShowClose: false,
      diaWidth: '500px',
      selectOptionWidth: '460',
      msgWidth: document.documentElement.clientWidth * 0.95 - 70,
      source: 'roompai',
      sendPdfEmail: false,
      sendEmail: '',
      check: false,
      clickCancel: true,
      bookingNoticeShow: false,
      specialInstructionsShow: false,
      cancelText: '',
      cancelDiaShow: false,
      cancelShowClose: false,
      customerEmail: '',
      phoneInternal: '',
      phoneExternal: '',
      TemporaryOrder: false,
      hotelLoading: true,
      orderLoading: true,
      priceLoading: true,
      noticeShow: false,
      priceHeight: 158,
      payHeight: 50,
      payAtHotel: true,
      conver: ''
    }
  },
  mounted () {
    this.getTime() // 调用定时器
    if (this.orderstatus === 3 || this.orderstatus === '3') {
      this.getOverTime() // 调用获取订单状态定时器
    }
    this.language = this.common.languageSet(this)
    this.currency = this.common.currencySet(this)
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
      this.reportNoShow = false
      this.reportShow = false
      this.diaWidth = '95%'
    } else {
      this.ismobile = false
      this.diaWidth = '500px'
    }
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    if (this.common.linkQuerys.orderno.startsWith('Temporary-')) {
      this.TemporaryOrder = true
      this.curPageData = 'TripDetailTemporary'
      console.log(this.curPageData)
    }
    this.getDetail()
    this.getContactInfo()
  },
  watch: {
    language: function (newCur, oldCur) {
      this.getDetail()
    }
  },
  methods: {
    setOptionWidth (event) {
      if (this.ismobile === true) {
        this.selectOptionWidth = event.view.innerWidth * 0.95 - 40
      }
    },
    hotelLanguage (language) {
      this.language = language
    },
    refreshUrl () {
      this.getDetail()
    },
    getTime () {
      var orderno = this.common.linkQuerys.orderno
      var time = parseInt(new Date().getTime() / 1000)
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getTripTime(data).then(res => {
        console.log(res)
        var time = parseInt(new Date().getTime() / 1000)
        if (res.flag === '200') {
          var orderstatus = res.data.order_status
          this.orderstatus = orderstatus
          var createtime = res.data.create_time
          var paytime = res.data.pay_time
          var waittime = parseInt(res.data.wait_time)
          if (orderstatus === '1') {
            this.remainTime = parseInt(createtime) + 300 - time
          } else {
            this.remainTime = parseInt(paytime) + waittime - time
          }
        } else {
          this.remainTime = 1800
        }
      })
      setInterval(() => {
        if (this.remainTime > 0) {
          this.remainTime -= 1
          this.countDown()
        } else {
          this.minuteString = '00'
          this.secondString = '00'
          this.check = true
        }
      }, 1000)
    },
    getOverTime () {
      var refreshtime = 700
      setInterval(() => {
        if (refreshtime > 0) {
          refreshtime -= 1
          if (refreshtime % 5 === 0) {
            this.getTripStatus()
          }
        }
      }, 1000)
    },
    goback () {
      // this.$router.push({name: 'MyTrip', query: {'source': this.source}})
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'MyTrip', params: {'querys': newQuerys}})
    },
    getDetail () {
      this.common.stopScroll()
      let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      var orderno = this.common.linkQuerys.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      var time = parseInt(new Date().getTime() / 1000)
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'currency': this.currency,
        'language': this.language,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getTripDetail(data).then(res => {
        if (res.flag === '001') {
          // this.$router.push({name: 'login', query: {'source': this.source}})
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          this.hotelDetail = res.data.hotelDetail
          this.orderDetail = res.data.orderDetail
          this.cancelText = this.orderDetail.cancel_txt_all
          this.check = this.orderDetail.check
          this.checkDetail = res.data.checkDetail
          this.payAtHotel = this.orderDetail.payAtHotel
          if ((this.language === 'zh' && this.orderDetail.surcharge_txt_zh !== '') || (this.language === 'en' && this.orderDetail.surcharge_txt_en !== '')) {
            this.noticeShow = true
          } else {
            this.noticeShow = false
          }
          if (res.data.orderDetail.child_order_status === '1' || res.data.orderDetail.child_order_status === 1) {
            this.childPaymentShow = true
            this.paymentShow = false
            this.cancelShow = false
            this.confirmShow = false
            this.noConfirmShow = false
          } else {
            this.childPaymentShow = false
            if (res.data.orderDetail.order_status === '1') {
              this.paymentShow = true
              this.cancelShow = false
              this.confirmShow = false
              this.noConfirmShow = false
              this.floatRight = true
            } else if (res.data.orderDetail.order_status === '2') {
              this.paymentShow = false
              this.cancelShow = false
              this.confirmShow = false
              this.noConfirmShow = true
            } else if (res.data.orderDetail.order_status === '3' || res.data.orderDetail.order_status === '6') {
              this.paymentShow = false
              this.cancelShow = false
              this.confirmShow = true
              this.noConfirmShow = false
              if (res.data.orderDetail.cancel_status === '1') {
                this.grayColor = true
              }
            } else {
              this.paymentShow = false
              this.cancelShow = true
              this.confirmShow = false
              this.noConfirmShow = false
              this.confirmMessShow = false
              this.cancelMessShow = true
            }
          }
          if (res.data.orderDetail.order_status === '1') {
            this.floatRight = true
          } else {
            this.floatRight = false
          }
          this.tripPdfInformation = {'Booking reference': this.orderDetail.orderno, 'Creation date': this.orderDetail.create_time_val, 'Hotel': this.hotelDetail.hotelname, 'Address': this.hotelDetail.hoteladdress, 'Property Contact Number': this.hotelDetail.tel, 'Lead guest': this.orderDetail.leadguest}
          if (this.ismobile === false) {
            this.reportShow = true
          }
          this.reportNoShow = false
        } else {
          // this.$router.push({name: 'MyTrip', query: {'source': this.source}})
          this.$router.push({name: 'MyTrip', params: {'querys': newQuerys}})
        }
        this.hotelLoading = false
        this.orderLoading = false
        this.priceLoading = false
        var that = this
        this.$nextTick(() => {
          this.priceHeight = that.$refs['divName'].clientHeight
          this.payHeight = that.$refs['payDiv'].clientHeight
        })
        this.common.canScroll()
      })
    },
    downloadPdf () {
      var orderno = this.common.linkQuerys.orderno
      var time = parseInt(new Date().getTime() / 1000)
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      downloadTrip(data).then(res => {
        console.log(res)
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          this.sendPdfEmail = true
          this.sendEmail = res.data.email
        }
      })
      // let data = Object.assign({}, this.$refs)
      // html2pdf(data.pdfDom, {
      //   margin: 1,
      //   filename: this.exportPDFtitle + '.pdf',
      //   image: {
      //     type: 'jpeg',
      //     quality: 1
      //   },
      //   html2canvas: {
      //     scale: 2,
      //     allowTaint: false,
      //     useCORS: true
      //   },
      //   jsPDF: {
      //     unit: 'pt',
      //     format: 'a4',
      //     orientation: 'landscape'
      //   }
      // })
    },
    reasonChange () {
      if (this.reason !== '50') {
        this.otherReason = false
      } else {
        this.otherReason = true
      }
      this.reasonMust = false
    },
    openCancelDia () {
      if (this.grayColor === true) {
        return false
      }
      this.openCancel = true
      // 获取扣款和退款金额
      var orderno = this.common.linkQuerys.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'currency': this.currency,
        'orderstatus': this.orderstatus,
        'language': this.language,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      // 埋点日志记录
      this.clickPageAction('click_cancel', '', dataJson, '', '')
      getCancelPriceDetail(data).then(res => {
        console.log(res)
        if (res.flag === '001') {
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          this.refundDetail = res.data.detail
          this.is_cancel = res.data.detail.is_cancel
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    cancelContinue () {
      var requestTime = parseInt(new Date().getTime())
      var responseTime = ''
      var orderno = this.common.linkQuerys.orderno
      var continueParams = {
        'orderno': orderno,
        'time': requestTime,
        'is_cancel': this.is_cancel
      }
      if (this.reason === '' || this.reason === undefined) {
        this.reasonMust = true
      } else if (this.reason === 50 || this.reason === '50') {
        var otherreason = this.$refs['otherreason'].value
        if (otherreason === '' || otherreason === 'null' || otherreason === undefined) {
          // 提醒
          this.otherReasonMsg = true
          return true
        } else {
          this.otherReasonMsg = false
          if (this.is_cancel === false) {
            this.clickPageAction('click_continue_cancel', '', continueParams, '', '')
            this.openCancel = false
            this.cancelContinueDia = true
            responseTime = parseInt(new Date().getTime())
            this.loadPageView(continueParams, {}, requestTime, responseTime)
          } else {
            this.checkCancelStatus()
          }
        }
      } else {
        this.otherReasonMsg = false
        if (this.is_cancel === false) {
          this.clickPageAction('click_continue_cancel', '', continueParams, '', '')
          this.openCancel = false
          this.cancelContinueDia = true
          responseTime = parseInt(new Date().getTime())
          this.loadPageView(continueParams, {}, requestTime, responseTime)
        } else {
          this.checkCancelStatus()
        }
      }
    },
    checkCancelStatus () {
      var orderno = this.common.linkQuerys.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      // 如果可取消，则再次确认是否可取消，如果不可取消，则弹框
      if (this.is_cancel === true || this.orderstatus === 2 || this.orderstatus === '2') {
        var dataJson = {
          'orderno': orderno,
          'time': time,
          'currency': this.currency,
          'language': this.language,
          'orderstatus': this.orderstatus,
          'token': token,
          'sessionid': sessionid
        }
        var data = this.common.encryptionData(dataJson, this)
        this.clickPageAction('recheck_cancel', '', dataJson, '', '')
        getCancelPriceDetail(data).then(res => {
          if (res.flag === '001') {
            // this.$router.push({name: 'login', query: {'source': this.source}})
            var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
            if (this.conver === 1 || this.conver === '1') {
              newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
            }
            this.$router.push({name: 'login', params: {'querys': newQuerys}})
          } else if (res.flag === '200') {
            if (res.data.detail.is_cancel === false) {
              this.openCancel = false
              this.cancelContinueDia = true
              this.refundDetail = res.data.detail
              this.is_cancel = res.data.detail.is_cancel
            } else {
              this.doCancel()
            }
          }
          return res
        }).then(res => {
          var responseTime = parseInt(new Date().getTime())
          this.$nextTick(() => {
            this.loadPageView(data, res, requestTime, responseTime)
          })
        })
      }
    },
    doCancel () {
      if (this.clickCancel === false) {
        return false
      }
      this.clickCancel = false
      var orderno = this.common.linkQuerys.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      var otherreason = this.$refs['otherreason'].value
      if (this.reason === '' || (this.reason === '50' && otherreason === '')) {
        this.openCancel = true
        this.cancelContinueDia = false
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'reason': this.reason,
        'otherreason': otherreason,
        'cancelprice': this.refundDetail.cancelprice,
        'refundprice': this.refundDetail.refundprice,
        'orderstatus': this.orderstatus,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      this.clickPageAction('do_cancel', '', dataJson, '', '')
      orderCancel(data).then(res => {
        this.clickCancel = true
        if (res.flag === '001') {
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          // 取消订单成功
          this.openCancel = false
          this.cancelContinueDia = false
          if (res.data.is_cancel === false) {
            this.cancelSuccessNoRefund = true
          } else {
            this.cancelSuccess = true
          }
        } else {
          // 取消订单失败
          this.openCancel = false
          this.cancelContinueDia = false
          this.cancelFailed = true
          this.orderDetail.com_cancel = false
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    closeCancel (txt) {
      var requestTime = parseInt(new Date().getTime())
      var orderno = this.common.linkQuerys.orderno
      var params = {
        'orderno': orderno,
        'time': requestTime,
        'how_many_times': txt
      }
      this.clickPageAction('close_cancel', '', params, '', '')
      this.openCancel = false
      if (txt === 'continue_cancel') {
        this.cancelContinueDia = false
      }
    },
    countDown () {
      let m = parseInt(this.remainTime / 60 % 60)
      let s = parseInt(this.remainTime % 60)
      if (m === 0 && s === 0) {
        this.getDetail()
      }
      this.minuteString = this.formatNum(m)
      this.secondString = this.formatNum(s)
    },
    getTripStatus () {
      var orderno = this.common.linkQuerys.orderno
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      getTripTime(data).then(res => {
        console.log(res)
        if (res.flag === '200') {
          var orderstatus = res.data.order_status
          if (this.orderstatus !== orderstatus) {
            this.getDetail()
          }
        }
      })
    },
    // doModifyOrderStatus () {
    //   var orderno = this.common.linkQuerys.orderno
    //   if (orderno === undefined) {
    //     this.detail = []
    //     return false
    //   }
    //   var time = parseInt(new Date().getTime() / 1000)
    //   var token = localStorage.getItem('token')
    //   var dataJson = {
    //     'orderno': orderno,
    //     'old_order_status': this.orderstatus,
    //     'order_status': 4, // 取消订单
    //     'time': time,
    //     'token': token
    //   }
    //   var data = this.common.encryptionData(dataJson, this)
    //   console.log(data)
    //   modifyOrderStatus(data).then(res => {
    //     console.log(res)
    //     if (res.flag === '001') {
    //       this.$router.push({name: 'login'})
    //     } else {
    //       this.getDetail()
    //     }
    //   })
    // },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    jumpDetail (hotelid, hotelname) {
      if (this.source === 'roompai' && hotelid !== '' && hotelid !== null && hotelid !== undefined) {
        // var date1 = new Date()
        // date1.setDate(date1.getDate() + 1)
        // var date2 = new Date(date1)
        // date2.setDate(date1.getDate() + 1)
        // var start = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
        // var end = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
        // 日期改为 跳转的时候，酒店详情页自动获取酒店当地时间，不通过这里的url设置，避免昨天点开的订单详情页，今天点击的酒店详情页
        // this.$router.push({name: 'HotelDetail', query: {'hotelid': hotelid, 'region': hotelname, 'room': 1, 'adult': 2, 'child': 0, 'language': this.language, 'currency': this.currency, 'source': this.source}})
        var newQuerys = this.common.linkEncode({'hotelid': hotelid, 'region': hotelname, 'room': 1, 'adult': 2, 'child': 0, 'language': this.language, 'currency': this.currency, 'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'hotelid': hotelid, 'region': hotelname, 'room': 1, 'adult': 2, 'child': 0, 'language': this.language, 'currency': this.currency, 'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'HotelDetail', params: {'querys': newQuerys}})
      }
    },
    getContactInfo () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'source': this.source,
        'time': time,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getContactInfo(data).then(res => {
        if (res.flag === '200') {
          this.customerEmail = res.data.customer_email_val
          this.phoneInternal = res.data.phone_internal_val
          this.phoneExternal = res.data.phone_external_val
        }
      })
    }
  }
}
</script>

<style scoped>
.el-main{text-align: left;}
.main{background-color: #fff;width:100%;position:relative;min-height: 900px;}
/*.main div{overflow:hidden;}*/
/* 清除浮动 */
  .clearBoth{clear:both;}
/* PC */
  /* 右侧 */
  .account-show{width: 100%; height: 100%;background:#FFFFFF;}
  .account-show .account-center{width: 82%;height:100%; float:right;background: #FFFFFF;}
  .account-center .account-data-info{width:70%;height:100%;margin:0 auto;}
  .account-data-info .account-callback{width: 100%;padding: 20px 0px;display: flex;/* justify-content: center; */align-items: center;cursor:pointer;}
  .account-callback img{width:18px;height:18px;margin-right:7px;}

  .account-data-info .order-status-num{width: 100%;height: 50px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size:14px;}
  .order-status-num .order-status-img{width:50px;height:50px;float:left;}
  .order-status-img img{width:35px;height:35px; margin:7.5px;}
  .order-status-num .order-status-desc{float:left;height: 100%;width:auto;line-height: 50px;padding-left:10px;overflow: hidden;}
  .order-status-num .twoline{line-height:17.5px !important;height: 35px;margin: 7.5px 0px;}
  .order-status-num .order-status-orderno{float:right;height: 100%;width:auto;line-height: 50px;overflow: hidden; white-space: nowrap;margin-right: 25px;}

  /* 酒店信息 */
  .account-data-info .hotel-info{height: 200px;width:100%;}
  .hotel-info .hotel-info-img{width:25%;height:100%;float:left;position: relative;}
  .hotel-info .hotel-info-img img{width: 100%; height: 100%;}
  .hotel-info .hotel-info-img .no-room-img{bottom:45px;height:35px;line-height:35px;}
  .hotel-info .hotel-info-img .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .hotel-info .hotel-info-data{width:75%;height:100%;background:white;float:left;}
  .hotel-info .hotel-info-data{font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 14px; color: #303133;}
  .hotel-info .hotel-info-data .hotel-info-data-center{margin: 20px 0px 20px 10px; height:160px;}
  .hotel-info-data-center .hotel-info-hotelname{font-size:16px;overflow: hidden; white-space: nowrap;}
  .hotel-info-data-center .hotel-info-star{padding:10px 0px 20px;}
  .hotel-info-data-center p{font-weight: 200;font-size:12px;display: flex;height:19px; line-height: 19px;}
  .hotel-info-data-center p img{width:20px;height:19px;margin-right:15px;}

  /* 订单详情 */
  .account-data-info .order-detail{width:100%;background:#F5F5F6;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-style: normal;font-size: 16px;}
  .order-detail .order-detail-line{width:100%;height:50px;line-height:50px;background:white;}
  .order-detail .order-detail-line .order-detail-center{height:100%;margin:0px 25px;overflow:hidden;}
  .order-detail-line .order-detail-line-left{width:50%;height:100%;float:left;font-weight: 650;}
  .order-detail-line .order-detail-line-left-sur{width:50%;height:40px;float:left;line-height: 40px;font-weight: 320; font-size:14px;}
  .order-detail-line .order-detail-line-left-sur-mess{width:100%;height:100%;float:left;font-weight: 340; font-size:12px;}
  .order-detail-center-pricemsg-en{min-height:40px; line-height:15px}
  .order-detail-center-pricemsg-zh{min-height:40px; line-height:40px}
  .order-detail-line .order-detail-line-right{ width: 50%; height: 100%; float: left; text-align: right; font-weight: 600; font-size: 14px;}
  .order-detail-line .order-detail-line-right-sur{ width: 50%; height:40px; float: left;line-height: 40px; text-align: right; font-weight: 320; font-size: 14px;}

  .order-detail .order-detail-main{width:100%;height:80%;}
  .order-detail .order-detail-main .order-detail-center{height:100%;margin:0 25px;}
  .order-detail .order-detail-main .order-detail-center .order-detail-main-line{width:100%;height:50px;font-size: 14px;}
  .order-detail .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-left{width:25%;height:100%;float:left;font-weight: 650;}
  .order-detail .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-right{width:75%;height:100%;float:left;}

  .order-detail-main-line-con{width:100%;height:85px;font-size: 14px;}
  .order-detail-main-line-con .order-detail-main-left{width:38%;height:100%;float:left;font-weight: 650;font-size:14px;}
  .order-detail-main-line-con .order-detail-main-right{width:62%;height:100%;text-align: right;overflow: hidden;font-size:14px; white-space: nowrap;}

  /* 价格详情 */
  .account-data-info .detail-two{width:100%;background:#F5F5F6;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-style: normal;font-size: 16px;}
  .detail-two .price-detail{float:left;width:49%;}
  .detail-two .email-detail{float:right;width:49%;}
  .detail-data .order-detail-line{width:100%;min-height:50px;line-height:50px;background:white;}
  .detail-data .order-detail-line .order-detail-center{height:50px;margin:0 25px;}
  .detail-data .order-detail-line .order-detail-line-all{overflow:hidden;font-weight: 650;}
  /* .detail-data .order-detail-line .order-detail-line-left{width:50%;height:100%;float:left;font-weight: 650;} */
  /* .detail-data .order-detail-line .order-detail-line-right{width:50%;height:100%;float:left;text-align:right;font-weight: 600;font-size: 14px;} */
  .detail-data .order-detail-main{width:100%;min-height:158px; background: #F5F5F6;}
  .detail-data .order-detail-main .order-detail-center{height:100%;margin:0 25px;}
  .detail-data .order-detail-main .order-detail-center .order-detail-main-line{width:100%;height:33px;font-size: 14px;}
  .detail-data .order-detail-main .order-detail-center .main-line-maxheight{height: 67px;}
  .detail-data .order-detail-main .order-detail-center .main-line-maxheight-two{height: 45px !important;}
  .detail-data .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-left{width:40%;height:100%;float:left;font-size:14px;}
  .order-detail-main-line .order-detail-main-left span{font-size: 12px;}
  .detail-data .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-right{width:60%;height:100%;float:left;font-size:14px;text-align:right;}
  .detail-two .float-right{float:right;}
  .detail-two .changeWidth{ width:100%;}
  .tax-margin /deep/ .el-dialog{display: flex;flex-direction: column;margin:0 !important;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}
  .tax-margin /deep/ .el-dialog .el-dialog__body{flex:1; overflow: auto;}
  .avgprice{display:block;color:#616161;font-size:12px;}
  /* 优惠券信息 */
  .coupon-info{min-height: 22px;font-size:12px; padding: 0 5px; border-radius: 5px;background-color: #d2e6c8;box-sizing: border-box;color: #2f7000;text-align: left;line-height: normal;margin: 0px 4.5%;font-size: 12px;line-height: 22px; display: flex;align-items: center;}
  .coupon-text{color: #2f7000;text-align: left;font-size: 12px;padding: 0 2.5% 0 4.5%;}
  .coupon-img{width:20px; height:20px;line-height: 22px;vertical-align: middle;}
  .coupon-info img{vertical-align: middle;}
  /* 订房须知 */
  .room-order-tips{width:100%; height: auto; background: white; box-shadow: 0 2px 12px #dcdfe2;}
  .room-order-tips-top{overflow: hidden; font-weight: 650;line-height: 50px;height: 50px;margin: 0 25px; font-size: 16px;}
  .room-order-tip-shadow{width:100%;box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);}
  .room-order-tips-info{font-size: 14px; margin:0 25px;padding-bottom: 15px;}
  /* 提示 */
  .account-data-info .tips-detail{width:100%;}
  .account-data-info .tips-detail .tips-one{width:100%;padding:10px 0px;background:red;display: flex;align-items: center;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400; font-style: normal;font-size: 12px;color: #909399;background:#F4F4F4;}
  .back-gray img{width:18px;height:18px;margin: 0px 10px;}
  .back-gray{width:28px;height:28px;background:rgba(144, 147, 153, 1);border-radius: 50%; margin:0 20px;}

  /* 按钮 */
  .account-data-info .button-detail{width:100%; text-align:right;}
  .button-detail button{width: 140px; height: 40px; border-radius: 4px; border: none; cursor: pointer; color: white;  margin-right: 5px;font-family: PingFangSCRegular, 'PingFang SC', sans-serif; font-weight: 400;font-style: normal;font-size: 14px;}
  .button-detail .button-report{background:rgba(230, 162, 60, 1);}
  .button-detail .button-report:hover{background:rgba(235, 181, 99, 1);}
  .button-detail .button-report-no{background:#ccc;}
  .button-detail .button-contact{background:rgba(64, 158, 255, 1);}
  .button-detail .button-contact:hover{background:rgba(62, 108, 234, 1);}
  .button-detail .button-cancel-none{background:rgba(250, 182, 182, 1); cursor: no-drop;}
  .button-detail .button-cancel{background:rgba(245, 108, 108, 1);}
  .button-detail .button-cancel:hover{background:rgba(247, 137, 137, 1);}
  .button-detail .button-pay{width:159px;height:40px;background:rgba(245, 108, 108, 1);}
  .button-detail .button-pay:hover{background:rgba(247, 137, 137, 1);}
    /* 取消订单弹框 */
  .dia-price{font-weight:100;height:50px;line-height: 25px; margin:10px 0px;border-bottom: 1px solid rgba(215, 215, 215, 1);}
  .dia-content{padding:0px 20px 50px;background-color: rgba(221, 223, 226, 0.2980392156862745);min-height:86px; background-size: 100%;}
  .dia-content-continue{padding:50px 20px;background-color: rgba(221, 223, 226, 0.2980392156862745);min-height:86px; background-size: 100%;}
  .dialog-close{width: 20%;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
  .dialog-close:focus{width: 20%;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
  .dialog-cancel, .dialog-cancel:focus{width: 30%;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
  .dia-content input:focus,.el-select /deep/ .el-input.is-focus .el-input__inner,.el-select /deep/ .el-input__inner:focus{ border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
  .cancelYes, .dialog-cancel:hover{background:rgba(252, 210, 5, 1);color:#4F4C4C;border: 1px solid rgba(252, 210, 5, 1);}
  .open-dia /deep/ .el-button+.el-button{margin-left:0px;}
  .open-dia /deep/ .el-button:hover{background-color:rgba(252, 210, 5, 1); color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
  .otherreason-msg{border:1px solid red;}
  .open-dia /deep/ .el-dialog__body{padding:0px;color:#333333;}
  .open-dia /deep/ .el-dialog__header{padding: 20px 20px;
    height: 40px;
    font-size: 22px;
    font-weight: 650;
    line-height: 40px;}
 .button-detail .gray-color{ background:rgba(221, 223, 226, 1);}
 .button-detail .gray-color:hover{background:rgba(221, 223, 226, 1);}
 .cancelmsg-text{ margin-bottom:10px; font-size:13px; overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;}

/* mobile */

/* 颜色 */
  .order-status-num .background-confirm{background:#34C447}
  .account-data-info .confirm-block{background:#EEF9EC;color: #34C447;}

  .order-status-num .background-noconfirm{background:#F8B360}
  .account-data-info .noconfirm-block{background:#FFF6EC;color: #FDB960;}

  .order-status-num .background-cancel{background:#38B3FF;}
  .account-data-info .cancel-block{background:#E9F5FF;color: #66B1FF;}

  .order-status-num .background-payment{background:#FF8383}
  .account-data-info .payment-block{background:#FFEFF0;color: #FF8383;}

  .order-status-num .background-childpay{background:#FCD205;}
  .account-data-info .childpay-block{background:#FFFFF0;color: ##4F4C4C;}

  .data-block{box-shadow: 0 2px 12px #dcdfe2;}
  .order-roominfo-clear{height:20px;width:100%;}
  .greenText{color:#2F7000 !important;}
  .redText{color:#E12D2D !important;}
  .el-select-dropdown__item{padding:0 15px !important;}
  .email-text{margin-right:20px}
  .blue-txt{color: rgb(83, 146, 249) !important;}

  /* 手机新增样式 */
  .mobile-date{line-height:30px; font-weight: 400;font-size: 14px; text-align: left; }
  .mobile-order-date{height:30px; color:#5392F9; background-color: rgba(255, 255, 255, 1); box-shadow: 0px 2px 12px rgb(0 0 0 / 35%);padding: 2px 0px 2px 10px;margin-top: 10px;}
  .mobile-cancel-date{height:30px; color:#FFFFFF; background-color: #5392F9;box-shadow: 0px 2px 12px rgb(0 0 0 / 35%);padding: 2px 0px 2px 10px;margin-top: 10px;}
  .twoline{ height: 40px; line-height: 20px; white-space: inherit;}
  .titletd{width: 40%; font-size: 12px; font-weight: 650; display: inline-block; vertical-align: top; color: #333333; float:left;}
  .infotd{width: 60%; display: inline-block; color: #333333; float:left;}
  .el-descriptions__table tr{ height: 32px;}
  /* 响应式 */
  @charset "UTF-8";

  @media only screen and (max-width:1099px){
      .main .menu-main{display:none}
      .main .account-show .account-center{width:100%;}
      .main .account-show .account-center .account-data-info{width:95%;}
      .order-status-num .order-status-desc{width:auto; overflow: unset; white-space: unset; margin-right:10px;}
      .order-status-num .order-status-orderno{width:auto;}
      .order-status-num{overflow:hidden;}

      /* 酒店信息 */
      .account-data-info .hotel-info{min-height: 300px; height:auto; box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); border-radius: 4px;padding-bottom: 10px; overflow-y: scroll;}
      .hotel-info-data-center .hotel-info-star{padding: 10px 0px 0px;}
      .hotel-info .hotel-info-data .hotel-info-data-center{margin: 20px 0px 0px 10px; height:auto;}
      .hotel-info .hotel-info-img{height:150px;width:100%;float:none;}
      .hotel-info .hotel-info-data{width:100%; height:auto;}
      .hotel-info-data-center .hotel-info-hotelname{min-height:25px;white-space: unset;}
      .detail-two .price-detail{width:100%;margin-bottom:20px;}
      .detail-two .email-detail{width:100%;}
      .addr-text{ height:auto !important;}
      .addr-text img{ vertical-align: middle;}
      .hotel-info-data-center p{font-weight: 400;font-size:12px;display: flex;height:16px; line-height: 16px;}
      .hotel-info-data-center p img{width:17px;height:16px;margin-right:15px;}
      .button-detail button{width:100%; margin-top:10px; margin-bottom:0px;}
      /* 订单详情 */
      .order-detail .order-detail-line .order-detail-center,.order-detail .order-detail-main .order-detail-center,.detail-data .order-detail-line .order-detail-center,.detail-data .order-detail-main .order-detail-center,.back-gray{margin: 0px 10px;}
      .order-detail .order-detail-main .order-detail-center .mobile-line{ height:50px !important;}
      .order-detail .order-detail-main .order-detail-center .order-detail-main-line{ font-size:12px; height:32px;}
      /* 支付详情 */
      .order-detail .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-left{width:40%;}
      .order-detail .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-right{width:60%; white-space: inherit;}
      .order-detail-main-line-con .order-detail-main-left{font-weight:400;}
      .mobile-select{ border-bottom: 1px solid rgba(221, 223, 226, 0.2980392156862745);}
      .email-text{margin-right:10px}
      .detail-data .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-left,.order-detail-main-line-con .order-detail-main-left{ width:60%;}
      .detail-data .order-detail-main .order-detail-center .order-detail-main-line .order-detail-main-right,.order-detail-main-line-con .order-detail-main-right{ width: 40%;}
      .dialog-close{width: 75px;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333; text-align:center;}
      .dialog-close:focus{width: 75px;background-color: #FFFFFF;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #333;}
      .dialog-cancel, .dialog-cancel:focus{width: 35%; background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF; text-align:center;}
      /* .el-select-dropdown{width:80% !important;} */
      .el-dialog{backface-visibility: hidden !important; -webkit-backface-visibility: hidden !important; -moz-backface-visibility: hidden !important;}
      .el-input__icon, .el-checkbox__inner::after{ transition: none !important;}
      .el-select--medium{ vertical-align: bottom !important;}
      .open-dia /deep/ .el-dialog{ -webkit-backface-visibility: hidden; }
      .dia-content /deep/ .el-dialog{ -webkit-backface-visibility: hidden; }
  }
  @media only screen and (min-width:1100px) {
    .el-main{width:1100px;margin:60px auto;}
    .main{background-color: #fff;position:relative;min-height: 600px;width:100%; margin: auto;}
    /* .menu-main{width: 255px;height: 100%;float: left;background-color: rgba(255, 255, 255, 1);border-right: none;-webkit-box-shadow: 0 2px 12px #ccc;box-shadow: 4px -2px 5px -3px #ccc;position: fixed;top: 60px;bottom: 300px;} */
    .menu-main{width: 255px;float: left;position: fixed;top: 60px;bottom: 360px;}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:100%;}
    .main .account-show .account-center .account-data-info .account-order-pc{}
    .main .account-show .account-center .account-data-info .account-order-mobile{display:none;}
    .account-show{width: 825px; height: 100%;background:#FFFFFF;float: right;padding: 0 10px;}
    .order-status-num .order-status-desc{width:auto;}
    .order-status-num .order-status-orderno{width:auto;}
    .order-status-num{overflow:hidden;}
  }
</style>
<style lang="scss">
/* 下载行程单 */
.pdf{width:1080px;height:auto;font-size:14px; margin: 0 auto;}
.pdf-main{width:100%;margin: 20px 0px;border:1px solid rgba(79, 76, 76, 1);height: 100%;}
.pdf-logo{width: 193px;height: 32px; margin:10px 0px;}
.score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
.scoreNo{height: 6px;border-radius: 100px;background-color: rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
.scoreYes{height: 100%;text-align: right;border-radius: 100px;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
.logo-text{font-weight: 650;font-style: normal;font-size: 22px;color: #333;display: inline-block;float: right;height: 53px;line-height: 53px;width:250px;}
/* .tr td{text-align:center;} */
.pdf-content{margin-top:10px;}
.pdf-information{height:28px; line-height: 28px;}
.pdf-information-top{margin-top:10px;}
.pdf-title{font-weight: 500;font-size: 18px;border-bottom: 1px solid rgba(215, 215, 215, 1);height: 34px;line-height: 34px;}
.information-left{width:40%;height:100%;float:left;}
.information-right{width:60%;height:100%;float:left;}
.pdf-content th{font-weight: 400; color:#333; font-size: 14px;}
.pdf-content .el-table th.el-table__cell.is-leaf{border-bottom: 1px solid #EBEEF5;}
.pdf-content .el-table td.el-table__cell{border-bottom:none;}
.pdf-payment{ float: left; width:48%; height:112px;}
.pdf-payment-info{height:28px; line-height: 28px; width:100%;}
.payment-left{width:70%; float:left;}
.payment-right{width:30%; float:left;}
.pdf-payment-right{ float:right; width:48%; height:92px; background-color: rgba(221, 223, 226, 0.2980392156862745); line-height: 22px;padding: 10px;}
.pdf-policy-text{ height:28px; line-height:28px;}
.policy-remarks{ background-color: rgba(221, 223, 226, 0.2980392156862745);line-height: 22px;padding: 10px 0;}
.pdf-contact-right{float:right; width:48%; height:130px;line-height: 25px;}
.pdf-notice div{line-height:28px;}
</style>



// WEBPACK FOOTER //
// src/components/account/tripDetail.vue